import React, { Component, Fragment } from 'react';

class SchoolDropdown extends Component {
    constructor(props){
        super(props);
        this.state={}
    }
    render() {
        return (
            <select className="form-control" 
                value={this.props.selectSchool} 
                onChange={(e)=>{
                    this.props.onSchoolChange(e.target.value);
                }}>
                    <option selected value={0}>All Schools</option>
                    {
                        (this.props.schoolList||[]).map((item,k)=>{
                            return <option key={k} value={item.schoolId}>{item.schoolName}</option>
                        })
                    }
            </select>
        );
    }
}

export default SchoolDropdown;


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/SchoolDropdown.jsx